import type { AmazonProfile } from "@adpilot/shared";

export function selectAllProfileIds(profiles: AmazonProfile[]): Set<string> {
  return new Set(profiles.map((profile) => profile.profileId));
}

export function toggleProfileId(selected: Set<string>, profileId: string): Set<string> {
  const next = new Set(selected);
  if (next.has(profileId)) next.delete(profileId);
  else next.add(profileId);
  return next;
}

export function selectedProfileIdsInOrder(
  profiles: AmazonProfile[],
  selected: Set<string>,
): string[] {
  return profiles
    .filter((profile) => selected.has(profile.profileId))
    .map((profile) => profile.profileId);
}
